import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_org/org/$orgId/jobs/offer/create/")({
  beforeLoad: () => {
    throw redirect({ to: "/org/providers" });
  },
});
